<template>
  <div class="gapFilling">

    <div class="single_question">
      <div class="question_title">
        <span>{{questionData.sectionName === undefined ? "" : questionData.sectionName}}</span>
        <span>({{questionData.sectionPrompt+"  本题"+questionData.score+"分。"}})</span>
      </div>

            <div class="title">
        <div v-if="questionData.questionContent" class=" editorShowArea ql-editor title_one" v-html="questionData.questionContent"></div>
              <div v-html="questionData.questionDto.questionContent"/>
            </div>
<!--      <div class="single_item" v-for="(data,index) in questionData.questionDto.items" :key="index">-->
<!--        <el-radio @change="save" class="single_radio" v-model="radio" :label="data.itemKey" :disabled="disabledFlag">{{null}}</el-radio>-->
<!--        <span style="float: left;margin-top:15px;" class="single_title">{{data.itemKey}}</span>-->
<!--        <span class="single_title  editorShowArea ql-editor" v-html="data.itemValue"></span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
  import {moduleId} from "../../../../../store/modules/exam";
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  export default {
    name: "single",
    data() {
      return {
        radio: '',
        answer:{},
        disabledFlag: true
      };
    },
    computed:{
      ...mapState(moduleId, {
        questionData: state => state.questionData,
        paperData: state => state.paperData,
        preAnswer: state => state.preAnswer,
      }),
    },
    watch:{
      //显示上次选择的答案
      preAnswer(newVal){
        this.answer = ''
        if(newVal !== null){
          this.answer = JSON.parse(newVal.answer);
          for (const newValKey in this.answer) {
            document.getElementsByName(newValKey)[0].value = this.answer[newValKey]
          }
          this.disabledFlag = false
        }else{
          this.disabledFlag = true
        }
      },
    },
    methods:{
      ...mapActions(moduleId,['saveAnswer']),
      getInput(){
        let elements = document.querySelectorAll("input.this_a_blank");
        if (!elements.length) return;
        [].forEach.call(elements, (item, index) => {
          let inputName = item.getAttribute("name");
          this.answer[inputName] = ""
          // if (!inputName) item.setAttribute("name", keyT + index); // key
          item.setAttribute("placeholder", "");
          item.addEventListener('blur', (event) => {
            this.answer[inputName] = event.target.value
            this.save()
          })
        });

      },
      save(){
        let obj = {
          "examPaperId":this.paperData.examPaperId,
          "subjectId":localStorage.getItem("subjectId"),
          "classId":this.$route.query.classId,
          "courseId":this.$route.query.id,
          "paperCode":this.$route.query.paperCode,
          "paperId":this.$route.query.paperId,
          "questionId":this.questionData.questionId,
          "questionType":1,
          "version":1,
          "userAnswer":JSON.stringify(this.answer),
          "score":this.questionData.score,
          "questionStatus":0,
          "useTime":"23",
          "type":this.$route.query.type
        };
        this.saveAnswer(obj);
      }
    },
    mounted() {
      this.getInput()
    }
  }
</script>

<style lang="scss" scoped>
  .gapFilling{
    .single_question {
      background: white;
      height: 100%;
      .question_title{
        margin-left: 30px;
        padding-top:30px;
        span:nth-child(1){
          font-size:18px;
          font-weight: bold;
        }
        span:nth-child(2){
          font-size:12px;
          font-weight: 500;
          margin-left: 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/gapFilling.vue